import {ConversationFilter} from '@/pages/ENT/Conversations/List/ConversationsPageContext';
import React from 'react';
import {SidebarItemBadge} from '../SidebarItemBadge';
import {useConversationCounts} from './ConversationCountsContext';

type Props = {
  children: React.ReactNode;
  badgeColor?: string;
};

const GREY_BADGE = 'grey.400';

const defaultBadgeColors: Partial<Record<ConversationFilter, string>> = {
  all: GREY_BADGE,
  snoozed: GREY_BADGE,
  assigned: GREY_BADGE,
  assignedToMyTeam: GREY_BADGE,
  unassigned: GREY_BADGE,
  fromEmail: GREY_BADGE,
  fromArk: GREY_BADGE,
};

const createConversationBadge = (filter: ConversationFilter) => {
  const BadgeComponent = (props: Props) => {
    const {counts} = useConversationCounts();

    return (
      <SidebarItemBadge
        badgeContent={counts[filter] || 0}
        badgeColor={props.badgeColor ?? defaultBadgeColors[filter]}
      >
        {props.children}
      </SidebarItemBadge>
    );
  };

  BadgeComponent.displayName = `ConversationsBadge(${filter})`;

  return BadgeComponent;
};

export const AllConversationsBadge = createConversationBadge('all');
export const NeedsResponseBadge = createConversationBadge('needsResponse');
export const SnoozedBadge = createConversationBadge('snoozed');
export const AssignedToMeBadge = createConversationBadge('assigned');
export const AssignedToMyTeamBadge =
  createConversationBadge('assignedToMyTeam');
export const UnassignedBadge = createConversationBadge('unassigned');
export const FromEmailBadge = createConversationBadge('fromEmail');
export const FromAppBadge = createConversationBadge('fromArk');
export const InactiveBadge = createConversationBadge('inactive');
